import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Renderer2, Inject } from '@angular/core';
import { FormsService } from "../../providers/forms.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseService } from "../../providers/firebase.service";
import { Client } from "../../models/client";
import { Observable } from "rxjs/Observable";
import { Form } from "../../models/forms";
import { FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { LocationInfo } from "../../models/locationInfo";
import 'rxjs/add/operator/finally';
import { isUndefined } from "util";
import { ScrollService } from "../../providers/scroll.service";
import { FormData } from '../../models/formData';
import { AWSConnectorService } from '../../providers/aws-connector';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';

declare const HelloSign: any;

@Component({
  selector: 'app-forms-retrieve-settings',
  templateUrl: './forms-retrieve-settings.component.html',
  styleUrls: ['./forms-retrieve-settings.component.css']
})
export class FormsRetrieveSettingsComponent implements OnInit, AfterViewInit {
  key: string;
  locKey: string;
  formKey: string;
  clientData: Client = new Client;
  locationData: LocationInfo = new LocationInfo;
  formData: FormData = new FormData();
  allForms: Observable<Array<Form>>;
  client: FirebaseObjectObservable<Client>;
  location: FirebaseObjectObservable<LocationInfo>;
  hellosignInserted = false;

  demoHellosignClientId = '9a0ada7c98dd0f7fc7de9d2b3d06b93a';

  loading = true;
  options: Object = {
    charCounterCount: true,
    fontSizeDefaultSelection: '14',
    heightMin: 500,
  };
  @ViewChild('moveInContract') moveInContract: ElementRef;
  public initControls;
  public deleteAll;
  public setHtml;
  public getHtml;
  public cleanHtml;
  public codeViewToggle;

  public initialize(initControls) {
    console.log(initControls)
    this.initControls = initControls;
    this.deleteAll = function () {
      this.initControls.getEditor()('html.set', '');
    };
    this.setHtml = function (lease) {
      this.initControls.getEditor()('html.set', lease);
    };
    this.getHtml = function (lease) {
      return this.initControls.getEditor()('html.get');
    };
    this.codeViewToggle = function () {
      return this.initControls.getEditor()('codeView.toggle');
    };
    this.cleanHtml = function (html) {
      return this.initControls.getEditor()('clean.html', html);
    };
  }

  constructor(
    private router: Router,
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    private awsConn: AWSConnectorService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.formKey = params['formKey'];
      this.client = this.afService.getClientInfo(this.key);
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;

        this.location = this.afService.getLocationInfo(this.key, this.locKey);

        // this.forms.getAllForms(this.clientData.propertySoftware, this.locKey, this.clientData.code).subscribe((forms) => {
        //   // console.log(forms)
        // });

        this.afService.getLocationInfo(this.key, this.locKey).subscribe((locationInfo) => {
          this.locationData = locationInfo;

          if (this.locationData.moveInContractType !== 'helloSign') {
            this.allForms = this.forms.getAllForms(this.clientData.propertySoftware, this.locKey, this.clientData.code);
          }

          this.afService.getLocationForm(this.key, this.locKey, this.formKey).subscribe((formData: FormData) => {
            this.formData = formData;
          });

          if (isUndefined(this.locationData.showMoveInContract)) {
            this.locationData.showMoveInContract = false;
          }

          if (isUndefined(this.locationData.showInsuranceContract)) {
            this.locationData.showInsuranceContract = false;
          }

          if (isUndefined(this.locationData.showAutoPayContract)) {
            this.locationData.showAutoPayContract = false;
          }

          if (isUndefined(this.locationData.moveInContract)) {
            this.locationData.moveInContract = [];
          }

          if (isUndefined(this.locationData.insuranceContract)) {
            this.locationData.insuranceContract = [];
          }

          if (isUndefined(this.locationData.autoPayContract)) {
            this.locationData.autoPayContract = [];
          }
        });

        this.loading = false;
      });

    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();

    if (this.locationData.moveInContractType !== 'helloSign') {
      // this.initControls.initialize();
    }
  }

  async testForm(isInsurance?: boolean) {
    this.loading = true;
    if (!this.hellosignInserted) {
      this.hellosignInserted = true;
      this._insertHellosignScript();
    }
    this.awsConn.helloSignGenerateLease(this.getTestData(isInsurance))
      .subscribe((signingData: { url: string, signatureRequestId: string }) => {
        try {
          this.loading = false;
          HelloSign.init(this.demoHellosignClientId);
          let hsObject: any = {
            url: signingData.url,
            // debug: true,
            allowCancel: true,
            skipDomainVerification: true,
            messageListener: (eventData) => {
              if (eventData.event == HelloSign.EVENT_SIGNED) {
                // do something for document getting signed
                if (!signingData.signatureRequestId || !eventData.signature_id) {
                  alert('HelloSign Error, check console');
                  console.warn(eventData);
                }
                else {
                  console.log(eventData);
                  HelloSign.close();
                  alert(environment.lambdaApi + 'hellosign-download-lease?signatureRequestId=' + signingData.signatureRequestId);
                  // this.scrollService.scrollToAnchor('move-onto-payment-button-row', 'center');
                }
              }
              else if (eventData.event == HelloSign.EVENT_CANCELED) {
                // they hit the close button after signing
                // this.helloSignWrapper.nativeElement.innerHTML = '<h2>Almost done! Click on the payment button to enter your payment details.</h2>'
                // this.scrollService.scrollToAnchor('move-onto-payment-button-row', 'center');
              }
              else if (eventData.event == HelloSign.EVENT_ERROR) {
                // do something for an error situation
                alert('HelloSign Error, check console');
                console.warn(eventData);
                HelloSign.close();
              }
            }
          };
          HelloSign.open(hsObject);
        }
        catch (e) {
          alert('HelloSign Error, check console');
          console.warn(e);
          HelloSign.close();
        }
      });
  }

  updateClient() {
    console.log(this.clientData)
    // this.afService.updateClient(this.clientData).then((data) => {
    //   this.afService.openSnackBar('Successfully saved esign Settings.');
    // });
  }

  updateLocation() {
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.openSnackBar('Location successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  updateForm() {
    this.afService.updateLocationForm(this.key, this.locKey, this.formData).then(() => {
      this.afService.openSnackBar('Form successfully updated.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  updateClientForms(data, tableName) {
    let lease = '';
    for (let item of this.locationData.moveInContract) {
      lease += item.formHtml;
    }

    this.setHtml(this.decodeHtml(lease));

    this.formData.formHtml = this.getHtml();
    // this.codeViewToggle();
    // this.setHtml(this.getHtml());
    // this.codeViewToggle();

    // this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
    //   this.afService.openSnackBar('Successfully saved esign Settings.');
    // });x
  }

  updateClientFormsRtf(data, tableName) {
    let lease = '';
    for (let item of this.locationData.moveInContract) {
      lease += item.formRtf;
    }

    this.setHtml(lease);
    // this.codeViewToggle();
    // this.setHtml(this.getHtml());
    // this.codeViewToggle();

    // this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
    //   this.afService.openSnackBar('Successfully saved esign Settings.');
    // });
  }

  decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  goBack() {
    this.router.navigate(['../../create-leases'], { relativeTo: this.route });
  }

  private _insertHellosignScript() {
    try {
      let helloSignScript = this.renderer.createElement('script');
      this.renderer.setAttribute(helloSignScript, 'id', 'hello-sign-script');
      this.renderer.setAttribute(helloSignScript, 'type', 'text/javascript');
      this.renderer.setAttribute(helloSignScript, 'src', 'https://s3.amazonaws.com/cdn.hellosign.com/public/js/hellosign-embedded.LATEST.js');
      this.renderer.appendChild(this.document.body, helloSignScript);
    }
    catch (e) {
      console.warn('Caught error inserting location HelloSign script:', e);
    }
  }

  getTestData(isInsurance?: boolean) {
    return {
      "clientCode": this.clientData.code,
      "locationKey": this.locKey,
      "leaseData": {
        "tenant": {
          "licenseExpiry": "License Expiry",
          "isSmsOptIn": true,
          "addr2": "Address 2",
          "date": "2019-11-09T21:39:03.348Z",
          "companyName": "Company Name",
          "altContactFirstName": "altContactFirstName",
          "altContactLastName": "altContactLastName",
          "altContactPhone": "123-456-7890",
          "webPassword": "d57ob4YeTe88Y1FqimMgp271T3Lr/9SK8o+V8tx3dm8=###1UKO19w9a788GsVV",
          "webPassword2": "",
          "isCommercial": false,
          "isCompanyTenant": false,
          "note": "registered on StoragePug website",
          "id": 108445,
          "firstName": "Richard",
          "lastName": "Jeffords",
          "email": "richard@storagepug.com",
          "addr1": "123 Easy St",
          "city": "Knoxville",
          "state": "TN",
          "zip": 37919,
          "phone": "999-999-9999",
          "cellPhone": "999-999-9999",
          "licenseNumber": 4619786976,
          "licenseState": "IL",
          "gateCode": 8673563576,
          "companyPhone": "",
          "hasActiveLedger": true,
          "dateOfBirth": "1990-10-10T04:00:00.000Z",
          "mrMrs": "mrMrs",
          "middleInitial": "middleInitial",
          "country": "country",
          "mrMrsAlt": "mrMrsAlt",
          "middleInitialAlt": "middleInitialAlt",
          "addr1Alt": "addr1Alt",
          "addr2Alt": "addr2Alt",
          "cityAlt": "cityAlt",
          "regionAlt": "regionAlt",
          "postalCodeAlt": "postalCodeAlt",
          "countryAlt": "countryAlt",
          "mrMrsBusiness": "mrMrsBusiness",
          "firstNameBusiness": "firstNameBusiness",
          "middleInitialBusiness": "middleInitialBusiness",
          "lastNameBusiness": "lastNameBusiness",
          "companyBusiness": "companyBusiness",
          "addr1Business": "addr1Business",
          "addr2Business": "addr2Business",
          "cityBusiness": "cityBusiness",
          "regionBusiness": "regionBusiness",
          "postalCodeBusiness": "postalCodeBusiness",
          "countryBusiness": "countryBusiness",
          "phoneBusiness": "phoneBusiness",
          "fax": "fax",
          "pager": "pager",
          "ssn": "ssn",
          "emailAlt": "emailAlt",
          "relationshipAlt": "relationshipAlt"
        },
        "unit": {
          "description": "",
          "discountAmount": 10,
          "discountAmountPushRate": 10,
          "discountChargeCategory": "Rent",
          "discountDescription": "",
          "discountId": 267,
          "discountMonthDiscountIsApplied": 1,
          "discountName": "Senior Citizen",
          "discountRequirePrepayMonths": 1,
          "discountShowOn": 1,
          "discountType": 1,
          "doorType": "Rollup",
          "entryType": "Exterior",
          "filterTypeClass": "portable",
          "floor": 1,
          "hasPower": false,
          "hasUnitAlarms": false,
          "isAda": 0,
          "isClimate": false,
          "isInside": false,
          "isMobile": true,
          "isOnWaitingList": false,
          "isRentable": true,
          "isRented": false,
          "leaseId": isInsurance ? this.formData.helloSignInsuranceTemplateId : this.formData.helloSignTemplateId,
          "length": 10,
          // "locationCode": "DEMO4",
          "pushRate": 200,
          "rate": 200,
          "size": "md",
          "squareFeet": 100,
          "standardSecurityDeposit": 100,
          "tax": 4,
          "unitId": 29895,
          "unitNumber": "PORT40",
          "unitType": "Portable",
          "unitTypeId": 194,
          "width": 10
        },
        "parkingVariables": {
          "vehicleType": "vehicleType",
          "year": "vehicleYear",
          "make": "vehicleMake",
          "model": "vehicleModel",
          "color": "vehicleColor",
          "serial": "vehicleSerial",
          "lienholder": "vehicleLienHolder",
          "address": "vehicleLienHolderAddress",
          "electricity": false
        },
        "date": "2019-11-09T21:39:03.354Z",
        "downloadUrl": "",
        "insuranceMonthlyCost": 35.95,
        "insuranceCoverageAmount": 15000,
        "location": {
          "helloSignClientId": this.demoHellosignClientId,
          "name": this.locationData.name,
          "phone": this.locationData.phone,
          "email": this.locationData.email,
          "address": this.locationData.address,
          "address2": this.locationData.address2
        },
        "chargesData": [
          {
            "amount": 200,
            "tax1": 7.6,
            "tax2": 9.5,
            "total": 207.1,
            "discountAmount": 10,
            "description": "First Monthly Rent Fee",
            "unitName": "PORT40",
            "startDate": "2019-11-09T00:00:00",
            "endDate": "2019-12-08T23:59:59"
          },
          {
            "amount": 10,
            "tax1": 1,
            "tax2": 0,
            "total": 11,
            "discountAmount": 0,
            "description": "Administrative Fee",
            "unitName": "PORT40",
            "startDate": "2019-11-09T00:00:00",
            "endDate": "2019-11-09T00:00:00"
          },
          {
            "amount": 100,
            "tax1": 0,
            "tax2": 0,
            "total": 100,
            "discountAmount": 0,
            "description": "Security Deposit",
            "unitName": "PORT40",
            "startDate": "2019-11-09T00:00:00",
            "endDate": "2019-11-09T00:00:00"
          },
          {
            "amount": 35.95,
            "tax1": 0,
            "tax2": 0,
            "total": 35.95,
            "discountAmount": 0,
            "description": "First Month Insurance",
            "unitName": "PORT40",
            "startDate": "2019-11-09T00:00:00",
            "endDate": "2019-12-08T23:59:59"
          }
        ],
        "clientCode": this.clientData.code,
        "locationKey": this.locKey,
        "moveInDate": "2019-11-09T21:38:51.895Z",
        "currentTime": "4:39 PM",
        "unitPrice": 200,
        "officeHours": "Mon-Fri: 10:00A-6:00P / Sat: 9:00A-4:00P",
        "gateHours": "6:00A-10P Daily",
        "facilityName": this.clientData.name
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-retrieve-settings/forms-retrieve-settings.component.ts